import { configureStore } from '@reduxjs/toolkit';

import authReducer from './authStore/slice';
import counterReducer from './counterStore/slice';
import userReducer from './userStore/slice';
import contactReducer from './contactStore/slice';
import contactTypeReducer from './contactTypeStore/slice';
import fileStoreReducer from './fileStoreStore/slice';
import labelReducer from './labelStore/slice';

const store = configureStore({
    reducer: {
        auth: authReducer,
        counter: counterReducer,
        user: userReducer,
        contact: contactReducer,
        contactType: contactTypeReducer,
        label: labelReducer,
        fileStore: fileStoreReducer,
    },
});

export default store;
